// removed by extract-text-webpack-plugin
module.exports = {"accaBoostInfo":"_12tTL9UoFsmL1edwRoZDfW"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/matchday/css/accaBonusMessageHeader.css
// module id = 726
// module chunks = 0